<div class="dialogContainer">
  <div class="header">
    <h2>{{ resultsShown() ? 'Import Results' : 'Import Quote Lines' }}</h2>
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
  @if (!resultsShown()) {
    <div class="content">
      <div class="templateLink">
        <button matButton="text" (click)="downloadTemplate()">
          <mat-icon class="size-16">download</mat-icon>
          <span>Download Import Template</span>
        </button>
      </div>
      <div class="dropZone" [class.dragOver]="isDragOver" [class.fileSelected]="fileName"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">
        @if (!fileName) {
          <mat-icon class="dropIcon">cloud_upload</mat-icon>
          <p>Drag and drop an Excel file here</p>
          <p class="orLabel">or</p>
          <input class="fileInput" type="file" id="importFileSelection" #importFileSelection
            accept=".xlsx,.xls" (change)="onFileSelected($event)" />
          <label for="importFileSelection" class="fileBrowseLabel">Browse Files</label>
        }
        @if (fileName) {
          <mat-icon class="selectedIcon">description</mat-icon>
          <p class="fileNameLabel">{{ fileName }}</p>
          <button matButton="text" class="clearButton" (click)="clearFile()">
            <mat-icon class="size-16">close</mat-icon>
            <span>Remove</span>
          </button>
        }
      </div>
    </div>
    <div mat-dialog-actions>
      <span class="spacer"></span>
      <span>
        <button matButton="elevated" (click)="cancel()">Cancel</button>
        <button class="primary-button" matButton="elevated" [disabled]="isBusy() || !fileBytes()" (click)="upload()">Import Lines</button>
      </span>
    </div>
  }
  @if (resultsShown()) {
    <div class="importResults">
      @if (successCount() > 0) {
        <div class="summaryItem success">
          <mat-icon class="size-16">check_circle</mat-icon>
          <span>{{ successCount() }} of {{ totalCount() }} lines imported successfully</span>
        </div>
      }
      @for (info of infoMessages(); track $index) {
        <div class="summaryItem info">
          <mat-icon class="size-16">info</mat-icon>
          <span>{{ info }}</span>
        </div>
      }
      @if (importErrors().length > 0) {
        <div class="summaryItem failure">
          <mat-icon class="size-16">error</mat-icon>
          <span>{{ importErrors().length }} lines had errors</span>
        </div>
        <div class="errorsWrapper">
          <table class="errorsTable">
            <thead>
              <tr>
                <td class="headerCell">#</td>
                <td class="headerCell">Error</td>
              </tr>
            </thead>
            <tbody>
              @for (error of importErrors(); track $index) {
                <tr>
                  <td class="errorCell rowNumCell">{{ $index + 1 }}</td>
                  <td class="errorCell">{{ error }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
    <div mat-dialog-actions>
      <span class="spacer"></span>
      <button class="primary-button" matButton="elevated" (click)="closeResults()">Close</button>
    </div>
  }
</div>
